(() => {
  const menu = document.querySelector('.header .menu');
  if (menu) {
    menu.setAttribute('aria-expanded', 'false');
    menu.addEventListener('click', () => {
      const open = document.querySelector('.header').classList.toggle('is-menu-open');
      menu.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    document.querySelectorAll('.header .nav a').forEach(link => link.addEventListener('click', () => {
      document.querySelector('.header').classList.remove('is-menu-open');
      menu.setAttribute('aria-expanded', 'false');
    }));
  }
  const moments = [...document.querySelectorAll('#story .moment')];
  const images = [...document.querySelectorAll('#story .journey-sticky img')];
  if (moments.length === images.length && moments.length) {
    let active = -1, scheduled = false;
    const syncStory = () => {
      scheduled = false;
      const story = document.getElementById('story').getBoundingClientRect();
      if (story.bottom < 0 || story.top > innerHeight) return;
      const focusLine = innerHeight * (innerWidth <= 720 ? .58 : .52);
      let chosen = 0, distance = Infinity;
      moments.forEach((moment, index) => {
        const rect = moment.getBoundingClientRect();
        const gap = Math.abs((rect.top + rect.bottom) / 2 - focusLine);
        if (gap < distance) { distance = gap; chosen = index; }
      });
      if (chosen === active) return;
      active = chosen;
      moments.forEach((moment, index) => moment.classList.toggle('active', index === chosen));
      images.forEach((image, index) => image.classList.toggle('active', index === chosen));
    };
    const requestSync = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(syncStory); } };
    addEventListener('scroll', requestSync, { passive: true });
    addEventListener('resize', requestSync, { passive: true });
    requestSync();
  }

  const shop = document.querySelector('#shop');
  if (shop) {
    const grid = shop.querySelector('.grid');
    const controls = document.createElement('div');
    controls.className = 'catalog-controls';
    controls.innerHTML = '<p>Browse the collection. Drag or use the arrows to see more.</p><div class="catalog-nav"><button type="button" class="catalog-prev" aria-label="Previous products">←</button><span class="catalog-count" aria-live="polite"></span><button type="button" class="catalog-next" aria-label="Next products">→</button></div>';
    grid.before(controls);
    const progress = document.createElement('div');
    progress.className = 'catalog-progress';
    progress.setAttribute('aria-hidden', 'true');
    progress.innerHTML = '<span></span>';
    grid.after(progress);
    const count = controls.querySelector('.catalog-count');
    const previous = controls.querySelector('.catalog-prev');
    const next = controls.querySelector('.catalog-next');
    const bar = progress.querySelector('span');
    const update = () => {
      const cards = [...grid.querySelectorAll('.card')];
      if (!cards.length) return;
      const nearest = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - grid.offsetLeft - grid.scrollLeft) < Math.abs(cards[best].offsetLeft - grid.offsetLeft - grid.scrollLeft) ? index : best, 0);
      count.textContent = `${String(nearest + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      previous.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
      const visible = Math.min(1, grid.clientWidth / grid.scrollWidth);
      bar.style.width = `${visible * 100}%`;
      bar.style.transform = `translateX(${(grid.scrollLeft / Math.max(1, grid.scrollWidth - grid.clientWidth)) * (1 - visible) * 100 / visible}%)`;
    };
    function move(direction) {
      const card = grid.querySelector('.card');
      if (card) grid.scrollBy({ left: direction * (card.getBoundingClientRect().width + 18), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    let drag = null;
    grid.addEventListener('pointerdown', event => { if (event.pointerType === 'mouse' && event.button === 0) drag = { x: event.clientX, left: grid.scrollLeft, moved: false }; });
    grid.addEventListener('pointermove', event => {
      if (!drag) return;
      const delta = event.clientX - drag.x;
      if (Math.abs(delta) > 8) { drag.moved = true; grid.classList.add('is-dragging'); grid.scrollLeft = drag.left - delta; }
    });
    const endDrag = () => { if (!drag) return; const moved = drag.moved; drag = null; grid.classList.remove('is-dragging'); if (moved) { grid.dataset.releaseClick = ''; setTimeout(() => delete grid.dataset.releaseClick, 80); } };
    grid.addEventListener('pointerup', endDrag);
    grid.addEventListener('pointercancel', endDrag);
    grid.addEventListener('click', event => { if (grid.dataset.releaseClick !== undefined) { event.preventDefault(); delete grid.dataset.releaseClick; } }, true);
    grid.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
  }

  if (matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)').matches) {
    const halo = document.createElement('div'); halo.className = 'mouse-halo';
    const point = document.createElement('div'); point.className = 'mouse-point';
    document.body.append(halo, point);
    let tx = -300, ty = -300, hx = tx, hy = ty, visible = false;
    addEventListener('pointermove', event => {
      if (event.pointerType !== 'mouse') return;
      tx = event.clientX; ty = event.clientY;
      if (!visible) { visible = true; halo.style.opacity = '1'; point.style.opacity = '1'; }
      point.classList.toggle('is-interactive', !!event.target.closest('a,button,.card'));
    }, { passive: true });
    addEventListener('pointerleave', () => { visible = false; halo.style.opacity = '0'; point.style.opacity = '0'; });
    const render = () => {
      hx += (tx - hx) * .11; hy += (ty - hy) * .11;
      halo.style.transform = `translate3d(${hx}px,${hy}px,0)`;
      point.style.transform = `translate3d(${tx}px,${ty}px,0)`;
      requestAnimationFrame(render);
    }; render();
  }
})();
